module.exports = {
    'promoter': require('./glyphs/promoter'),
    'res': require('./glyphs/res'),
    'cds': require('./glyphs/cds'),
    'terminator': require('./glyphs/terminator'),
    'non-coding-rna-gene': require('./glyphs/ncrna'),
    'origin-of-replication': require('./glyphs/oor'),
    'origin-of-transfer': require('./glyphs/oot'),
    'primer-binding-site': require('./glyphs/primer'),
    'sticky-restriction-site-3': require('./glyphs/stickyressite3'),
    'sticky-restriction-site-5': require('./glyphs/stickyressite5'),
    'assembly-scar': require('./glyphs/assemblyscar'),
    'operator': require('./glyphs/operator'),
    'insulator': require('./glyphs/insulator'),
    'blunt-restriction-site': require('./glyphs/brs'),
    'overhang-site-3': require('./glyphs/os3'),
    'overhang-site-5': require('./glyphs/os5'),
    'engineered-region': require('./glyphs/engineeredregion'),
    'aptamer': require('./glyphs/aptamer'),
    'poly-a': require('./glyphs/polyasite'),
    'recombination-site': require('./glyphs/recombinationsite'),
    'signature': require('./glyphs/signature'),
    'biopolymer-base': require('./glyphs/biopolymerbase'),
    'restriction-site': require('./glyphs/restrictionsite'),
    'rna': require('./glyphs/rna'),
    'protein': require('./glyphs/protein'),
    'dna-stability': require('./glyphs/dnastability'),
    'molecule': require('./glyphs/molecule'),
    'unspecified': require('./glyphs/unspecified'),
    'no-glyph-assigned': require('./glyphs/noglyph'),
}